import * as React from "react";
const SvgArrowUpFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 8, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 0L0.669872 7.5L9.33013 7.5L5 0Z", fill: "#9B00EC" }));
export default SvgArrowUpFilled;
